import { BanTabsProps } from './interface'

export function withBanTabs(Component: React.FC<BanTabsProps>) {
  function WithBanTabs(props: BanTabsProps) {
    return <Component {...props} />
  }

  return WithBanTabs
}
